import axios from 'axios';
import router from '../router';
import vue from 'vue'
import store from '../vuex/store';
import { Message } from 'element-ui';
import moment from 'moment';

// 通用公用方法
const req = (method, url, params) => {
    // 控制账户锁定状态
    if (url == '/login') {
        let allcout = JSON.parse(localStorage.getItem('allcounts'))
        if (allcout) {
            let indexofcout = allcout.findIndex(item => item.account == params.account)
            if (indexofcout >= 0) {

                if (allcout[indexofcout].lock == 1) {
                    if (moment().valueOf() >= allcout[indexofcout].time) {
                        allcout.splice(indexofcout, 1)
                        localStorage.setItem('allcounts', JSON.stringify(allcout))
                    } else {
                        let mim = moment(Number(allcout[indexofcout].time) - Number(moment().valueOf())).format('m')
                        Message.warning(`您的密码连续输错十次，账户已被锁定，请您${mim}分钟后重新登录。`)
                        return
                    }

                }
            }
        }
    }
    // 请求
    return new Promise((resolve, reject) => {
        console.log();
        axios({
            method: method,
            url: 'https://lxwhfz.usx.edu.cn' + url,   //线上服务器url 'lxwhfz.usx.edu.cn:1640'
            // url: vue.prototype.$api + url,         //本地url
            headers: {
                'Content-Type': 'application/json',
                token: store.state.usuerdata.token
            },
            data: params,

        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                if (err.response.data.msg == '令牌无效') {
                    store.commit("logout", "false");
                    localStorage.removeItem("vuex");
                    router.replace("/").catch(() => { });
                }

                // 密码错误判断
                if (err.response.data.msg == '密码错误') {
                    let allcounts = JSON.parse(localStorage.getItem('allcounts'))
                    if (allcounts) {
                        let indexoftype = allcounts.findIndex(item => item.account == params.account)
                        if (indexoftype >= 0) {
                            if (allcounts[indexoftype].errcount >= 9) {
                                allcounts[indexoftype].lock = 1
                                allcounts[indexoftype].time = moment().add(10, 'm').valueOf();

                                Message.warning(`您的密码连续输错十次，账户已被锁定，请您10分钟后重新登录。`)
                                localStorage.setItem('allcounts', JSON.stringify(allcounts))
                                reject(err.data)
                                return
                            } else {
                                allcounts[indexoftype].errcount += 1
                                Message.warning(`请输入正确的登录密码，连续输错10次后，账号将被锁定并限制登录，您还可以重${10 - allcounts[indexoftype].errcount}次`)
                                localStorage.setItem('allcounts', JSON.stringify(allcounts))
                            }

                        } else {

                            let paramsdata = {
                                account: params.account,
                                errcount: 1
                            }
                            allcounts.push(paramsdata)
                            Message.warning(`请输入正确的登录密码，连续输错10次后，账号将被锁定并限制登录，您还可以重9次`)
                            localStorage.setItem('allcounts', JSON.stringify(allcounts))
                        }
                    } else {

                        let paramsdata = [
                            {
                                account: params.account,
                                errcount: 1
                            }
                        ]
                        Message.warning(`请输入正确的登录密码，连续输错10次后，账号将被锁定并限制登录，您还可以重9次`)
                        localStorage.setItem('allcounts', JSON.stringify(paramsdata))

                    }

                    reject(err.data)
                } else {
                    Message.warning(err.response.data.msg)
                    reject(err.data)
                }
                reject(err.data)
            })
    })

};
const reqfile = (method, url, params) => {
    return axios({
        method: method,
        responseType: 'blob',
        url: 'https://lxwhfz.usx.edu.cn' + url,     //线上服务器url
        // url: vue.prototype.$api + url,           //本地url
        headers: {
            'Content-Type': 'application/json',
            token: store.state.usuerdata.token
        },
        data: params,

    })
        .then(res => res.data)

};

export {

    reqfile,
    req
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js